import { render, staticRenderFns } from "./cmp-chat.vue?vue&type=template&id=d19e57b4&"
import script from "./cmp-chat.vue?vue&type=script&lang=js&"
export * from "./cmp-chat.vue?vue&type=script&lang=js&"
import style0 from "./cmp-chat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports